// Get combined job interview questions (requirements + company) **********************************
// pathname: /v1/job-interview/{slug}/questions
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi';

/** Props */
interface UseSwrJobCombinedQuestionsProps {
  locale: Locale;
  jobSlug: string;
  shouldFetch?: boolean;
}

/**
 * @description SWR: fetch combined job interview questions (requirements + company text questions).
 * - `locale` - the current locale
 * - `jobSlug` - the job slug
 * - `shouldFetch` - condition for fetching the data. Default true.
 */
export const useSwrJobCombinedQuestions = (props: UseSwrJobCombinedQuestionsProps) => {
  const {
    locale,
    jobSlug,
    shouldFetch = true,
  } = props;

  return useSwrApi<ApiSchema<'CombinedQuestionsListRead'>>({
    url: `/v1/job-interview/${jobSlug}/questions`,
    locale,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
      revalidateOnMount: true,
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });
};
